module.exports = __webpack_public_path__ + "static/media/footer_contact_whatsapp_v2.0ce32397.svg";